import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";
import { parseCourseStatus } from "../utils/parseCourseStatus";

export const getExtraCourses = async (params) => {
  let unfilteredItems = [];

  try {
    const res1 = await axios.middleware("/aluno.asmx/disciplinas_extras", {
      params,
    });
    unfilteredItems.push(
      ...res1[0].data?.map((course) => ({
        ...course,
        ...parseCourseStatus(course),
      }))
    );
  } catch (e) {}
  try {
    const res2 = await axios.middleware(
      "/aluno.asmx/disciplinas_extras_convenio",
      {
        params,
      }
    );
    unfilteredItems.push(
      ...res2[0].data?.map((course) => ({
        ...course,
        ...parseCourseStatus(course),
      }))
    );
  } catch (e) {}
  try {
    const res3 = await axios.middleware("/aluno.asmx/Disciplinas_Loja", {
      params,
    });
    unfilteredItems.push(
      ...res3[0].data?.map((course) => ({
        ...course,
        ...parseCourseStatus(course),
      }))
    );
  } catch (e) {}
  return unfilteredItems;
};

export const useExtraCourses = ({ config, params = {} } = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "extraCourses",
      { studentId: _cookies.getItem("auth").user.alunoid, ...params },
    ],
    queryFn: () =>
      getExtraCourses({
        alunoid: _cookies.getItem("auth").user.alunoid,
        ...params,
      }),
  });
};
